import { useRef } from 'react';

/**
 * Returns `true` if the hook is running for the first time
 * and `false` if it's already run before. Useful for logic
 * that you want to execute exactly once.
 */
export const useIsFirstRender = (): boolean => {
  const isFirst = useRef(true);

  if (isFirst.current) {
    isFirst.current = false;

    return true;
  }

  return isFirst.current;
};
